import React from 'react';
import ModalFooter from 'components/modal/components/footer/ModalFooter';
import ModalFooterButtonCancel from 'components/modal/components/footer/ModalFooterButtonCancel';
import CornerDialog from './CornerDialog';
const CornerDialogCloseOnly = ({ children, isShown, onClose, ...rest }) => (React.createElement(CornerDialog, { hasFooter: false, isShown: isShown, onCloseComplete: onClose, ...rest },
    React.createElement("p", { className: "text-grey-70 leading-5 mb-12" }, children),
    React.createElement(ModalFooter, { className: "ledger-footer" },
        React.createElement(ModalFooterButtonCancel, { buttonText: "Close", onCloseModal: onClose }))));
export default CornerDialogCloseOnly;
